export default __webpack_public_path__ + "static/vizio-58ddd629362b145e8ed8143544b7b1fc.png";